module.exports = __webpack_public_path__ + "img/img_sanbu@2x.3c252281.png";